import { Location } from 'history';
import * as React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { match, Redirect, Route, RouteComponentProps, Switch } from 'react-router';

import { PublishedConnectionSubspaceName } from '~src/app/state/SpaceInfo';

import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { AppState } from '../../app/state/AppState';
import { PublishedConnectionSpaceProvider } from './PublishedConnectionSpaceProvider';

export interface PublishedConnectionRouteParams {
  readonly id: string;
}

export interface PublishedConnectionRouteComponentProps extends RouteComponentProps<PublishedConnectionRouteParams> {
  readonly match: match<PublishedConnectionRouteParams>;
  readonly location: Location;
}

export interface PublishedConnectionSpaceRouterOwnProps {
  readonly siteName: string;
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export interface PublishedConnectionSpaceRouterStateProps {
  readonly isRequestAccessEnabled: boolean;
}

export type PublishedConnectionSpaceRouterProps =
  PublishedConnectionRouteComponentProps &
  PublishedConnectionSpaceRouterOwnProps &
  PublishedConnectionSpaceRouterStateProps;

export class PublishedConnectionSpaceRouterComponent extends React.Component<PublishedConnectionSpaceRouterProps, {}> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.publishedConnectionPath(':id')} render={(routeProps: PublishedConnectionRouteComponentProps) =>
          <Redirect to={this.props.urls.publishedConnectionOverviewPath(routeProps.match.params.id)} />
        } />
        <Route exact path={this.props.urls.publishedConnectionOverviewPath(':id')} render={this.spaceProviderFor('tables')} />
        <Route exact path={this.props.urls.publishedConnectionScheduledTasksPath(':id')} render={this.spaceProviderFor('scheduledTasks')} />
        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private spaceProviderFor = (subplace: PublishedConnectionSubspaceName): (routeProps: PublishedConnectionRouteComponentProps) => JSX.Element => {
    return (routeProps: PublishedConnectionRouteComponentProps) => {
      return (
        <PublishedConnectionSpaceProvider
          siteName={this.props.siteName}
          publishedConnectionId={routeProps.match.params.id}
          siteUrls={this.props.urls}
          subplaceName={subplace}
          routeLocationSearch={routeProps.location.search}
          routeLocationPath={routeProps.location.pathname}
          isRequestAccessEnabled={this.props.isRequestAccessEnabled}
        />
      );
    };
  }
}

const mapStateToProps: MapStateToProps<PublishedConnectionSpaceRouterStateProps, PublishedConnectionSpaceRouterOwnProps, {}> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state)
});

export const PublishedConnectionSpaceRouter: React.ComponentClass<PublishedConnectionSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, { pure: false })(PublishedConnectionSpaceRouterComponent);
